import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import md5 from 'js-md5';
import { fetchCode, sendCodePwdSMS, validationCodeSMS, updatePwdByAccPhone, getUserInfoByAcc } from '@/api/forget'; // import { validUsername } from '@/utils/validate'

export default {
  name: 'Forget',
  data: function data() {
    var _this = this;

    var LxStr = function LxStr(str) {
      var arr = str.split('');
      var flag = true;

      for (var i = 1; i < arr.length - 1; i++) {
        var firstIndex = arr[i - 1];
        var secondIndex = arr[i];
        var thirdIndex = arr[i + 1];
        thirdIndex - secondIndex === 1;
        secondIndex - firstIndex === 1;

        if (thirdIndex - secondIndex === 1 && secondIndex - firstIndex === 1) {
          flag = false;
        }
      }

      return flag;
    };

    var validateUsername = function validateUsername(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入用户名！'));
      } else {
        callback();
      }
    };

    var validateVcode = function validateVcode(rule, value, callback) {
      // 将用户输入数字转成字符串，同时转换成大写
      // value = value + ''
      // if (value.length > 4) {
      //   value = value.substring(0, 4)
      //   this.$set(this.loginForm, 'vcode', value)
      // }
      if (value.length !== 4) {
        callback(new Error('请输入验证码！'));
      } else {
        callback();
      }
    }; // 设置新密码


    var validatePass = function validatePass(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入密码'));
      } else {
        var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@#!%*?&._])[A-Za-z\d$@#!%*?&._]{8,16}/;

        if (value.length < 8 || value.length > 16) {
          callback(new Error('密码长度必须为8~16位'));
        } else if (!reg.test(value)) {
          callback(new Error('密码必须同时包含大小写字母、数字、特殊字符'));
        } else if (!LxStr(value)) {
          callback(new Error('数字不能连续三位'));
        } else {
          callback();
        }
      }
    };

    var validatePass2 = function validatePass2(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入确认密码'));
      } else if (value !== _this.childData.userPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      loginForm: {
        userName: '',
        validateCode: '',
        uuid: '',
        platformType: 1 // 平台类型：1物业端   2监管、社区端

      },
      loginRules: {
        userName: [{
          required: true,
          trigger: 'blur',
          validator: validateUsername
        }],
        validateCode: [{
          required: true,
          validator: validateVcode,
          triger: 'blur'
        }]
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      ccode: '',
      codesrc: '',
      steps: 0,
      smsCode: '',
      phoneNumb: '',
      // 设置新密码
      childData: {
        userPwd: ''
      },
      rules: {
        userPwd: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }, {
          validator: validatePass,
          trigger: 'blur'
        }],
        cifrmUserPwd: [{
          required: true,
          message: '请输入确认密码',
          trigger: 'change'
        }, {
          validator: validatePass2,
          trigger: 'blur'
        }]
      },
      count: '',
      showGet: true,
      timer: null,
      tenNum: ''
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created: function created() {
    this.getCode();
  },
  methods: {
    // 上一步
    handleLast: function handleLast() {
      if (this.steps > 0) {
        this.steps -= 1;
      }
    },
    // 下一步
    handleNext: function handleNext() {
      var _this2 = this;

      // var isPass = true
      // 验证账户
      if (this.steps === 0) {
        var vcode = this.loginForm.validateCode.toUpperCase();
        this.$set(this.loginForm, 'validateCode', vcode);
        getUserInfoByAcc(this.loginForm).then(function (r) {
          if (r.data.code === 200) {
            _this2.Alert({
              alertType: 'update',
              message: '验证成功'
            });

            _this2.phoneNumb = r.data.data.mobilephone;

            if (_this2.steps < 3) {
              _this2.steps += 1;
            }
          } else {
            return;
          }
        });
      } // 手机验证码


      if (this.steps === 1) {
        var vaildSms = {
          platformType: 1,
          phoneNumb: this.phoneNumb,
          smsCode: this.smsCode
        };
        validationCodeSMS(vaildSms).then(function (r) {
          if (r.data.code === 200) {
            if (_this2.steps < 3) {
              _this2.steps += 1;
            }

            _this2.Alert({
              alertType: 'update',
              message: '验证成功'
            });
          } else {
            return; // isPass = false
          }
        });
      } // 设置新密码


      if (this.steps === 2) {
        this.$refs['dataForm'].validate(function (valid) {
          if (valid) {
            var childDataClone = JSON.parse(JSON.stringify(_this2.childData));
            _this2.childData.userPwd = md5(childDataClone.userPwd);
            updatePwdByAccPhone(_this2.loginForm.userName, _this2.childData.userPwd).then(function (r) {
              if (r.data.code === 200) {
                _this2.Alert({
                  alertType: 'update',
                  message: '设置成功'
                });

                if (_this2.steps < 3) {
                  _this2.steps += 1;
                }

                _this2.tenDown();
              }
            });
          } else {
            _this2.Alert({
              alertType: 'valid'
            });
          }
        });
      } // 设置成功


      if (this.steps === 3) {
        console.log(this.steps);
      }
    },
    // 获取验证码
    getCode: function getCode() {
      var _this3 = this;

      fetchCode({}).then(function (res) {
        if (res.data.code === 200) {
          _this3.codesrc = res.data.data.image;
          _this3.loginForm.uuid = res.data.data.uuid;
        }
      });
    },
    generatedCode: function generatedCode() {
      var random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
      var code = '';

      for (var i = 0; i < 4; i++) {
        var index = Math.floor(Math.random() * 36);
        code += random[index];
      }

      this.ccode = code;
    },
    handleCode: function handleCode() {
      // 生成验证码
      // this.generatedCode()
      this.getCode();
    },
    checkCode: function checkCode() {
      // 判断验证码是否输入准确
      var vcode = this.loginForm.vcode;
      vcode = vcode.toUpperCase();
      var ccode = this.ccode;
      ccode = ccode.toUpperCase();

      if (vcode !== ccode) {
        this.$message.error('验证码有误，请重新输入！');
        this.$set(this.loginForm, 'vcode', '');
      } else {
        return 1;
      }
    },
    // 获取短信验证
    getPhoneCode: function getPhoneCode() {
      var _this4 = this;

      var getCode = {
        platformType: 1,
        phoneNumb: this.phoneNumb
      };
      sendCodePwdSMS(getCode).then(function (res) {
        if (res.data.code === 200) {
          _this4.Alert({
            alertType: 'update',
            message: '获取成功'
          });
        }
      });
      this.getCodes();
    },
    // 倒计时
    getCodes: function getCodes() {
      var _this5 = this;

      var TIME_COUNT = 60;

      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showGet = false;
        this.timer = setInterval(function () {
          if (_this5.count > 0 && _this5.count <= TIME_COUNT) {
            _this5.count--;
          } else {
            _this5.showGet = true;
            clearInterval(_this5.timer);
            _this5.timer = null;
          }
        }, 1000);
      }
    },
    // 10s
    tenDown: function tenDown() {
      var _this6 = this;

      var TIME_COUNTs = 10;
      this.tenNum = TIME_COUNTs;
      setInterval(function () {
        if (_this6.tenNum > 0 && _this6.tenNum <= TIME_COUNTs) {
          _this6.tenNum--;

          if (_this6.tenNum === 0) {
            console.log('this.tenNum ');
            console.log(_this6.tenNum);

            _this6.$router.push({
              path: '/login'
            });
          }
        }
      }, 1000);
    },
    handCreate: function handCreate() {
      this.$router.push({
        path: '/login'
      });
    }
  }
};